import type { FieldError, Merge } from "react-hook-form";
import { cn } from "../lib/utils";

type FormFieldErrorProps = {
	error?: FieldError | Merge<FieldError, (FieldError | undefined)[]>;
	errorMessage?: string;
	className?: string;
};

export const FormFieldError = ({ error, errorMessage, className }: FormFieldErrorProps) =>
	error ? (
		<div
			className={cn(
				"absolute left-0 top-[-8px] mx-[8px] px-[4px] bg-surface-base text-[12px] leading-[16px] font-normal text-red-400",
				className,
			)}
		>
			{errorMessage ?? error.message}
		</div>
	) : null;
